import { tap } from 'rxjs';

import { Injectable } from '@angular/core';

import { AuthStore } from '@/app/core/store/auth';
import { HttpService } from '@/app/core/services/http';

import { Profile, ChangeOwnPasswordPayload } from './profile.types';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(
    private http: HttpService,
    private authStore: AuthStore,
  ) {}

  getProfile() {
    return this.http.get<Profile>('/v1/profile').pipe(tap((user) => this.authStore.setAuthUser(user)));
  }

  changePassword(payload: ChangeOwnPasswordPayload) {
    return this.http.put<Profile>('/v1/profile/password', payload);
  }
}
